export const ENUM_STORAGE_PATH = 'path';
export const ENUM_STORAGE_ACCESS_TOKEN = 'atna2r1zlh49ru58cdd1q32fh6or7b';
export const ENUM_STORAGE_REFRESH_TOKEN = 'rtna2r1zlh49ru58cdd1q32fh6or7b';
export const ENUM_STORAGE_LANGUAGE = 'i18nextLng';
export const ENUM_STORAGE_ANIMATOR_TAB = 'animatorTab';
